module.exports = __webpack_public_path__ + "static/media/dwh.4f5343ee.png";